import { TranslateService } from '@ngx-translate/core';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild, viewChild } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { Router } from '@angular/router';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { environment } from '../../../environments/environment';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import { sleep, venueAcceptsOrders } from '../../../smoothr-web-app-core/utils/utils';
import Venue from '../../../smoothr-web-app-core/models/Venue';
import { OrderType } from 'src/smoothr-web-app-core/enums/OrderType';
import { NavigationService } from 'src/app/services/navigation.service';
import { ModalController, PopoverController } from '@ionic/angular';
import { SelectLanguagePopoverComponent } from 'src/app/components/select-language-popover/select-language-popover.component';
import { MapsUtils } from 'src/smoothr-web-app-core/utils/maps-utils';
import Order from 'src/smoothr-web-app-core/models/Order';
import { Api } from 'src/smoothr-web-app-core/api/api';
import { EnterFoodspotCodeModalComponent } from 'src/app/components/enter-foodspot-code-modal/enter-foodspot-code-modal.component';
import { TimeUtils } from 'src/smoothr-web-app-core/utils/time-utils';
import { Swiper, SwiperOptions } from 'swiper/types';
import { SignInModalComponent } from 'src/app/components/sign-in-modal/sign-in-modal.component';
import { SignUpModalComponent } from 'src/app/components/sign-up-modal/sign-up-modal.component';
import { Subject } from 'rxjs';
import { AppRestorePasswordModalComponent } from '../../components/app-restore-password-modal/app-restore-password-modal.component';
import { AnalyticsService } from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import { FacebookPixelEvent } from '../../../smoothr-web-app-core/enums/facebook-pixel-event';

enum Language {
	GreatBritain = 'en',
	German = 'de',
}

@Component({
	selector: 'app-home',
	templateUrl: './home.page.kaisin.html',
	styleUrls: ['./home.page.kaisin.scss'],
})
export class HomePage extends RepositoryDirective implements OnInit, AfterViewInit, OnDestroy {
	@ViewChild('swiperRef', { static: false }) swiper: ElementRef;

	static url = 'home';
	environment = environment;
	languageEnum = Language;
	orders: Order[] = [];
	selectedPreorderType: PreorderType = null;
	loading = false;
	opened = false;
	selectedLanguage = Language.German;

	// public contentCards$ = this.brazeService.contentCards$;

	flashcards: { prompt: string; id: number }[] = [];
	destroy$ = new Subject();

	constructor(
		protected repository: RepositoryService,
		private router: Router,
		public translate: TranslateService,
		private navigationService: NavigationService,
		private modalCtrl: ModalController,
		private popover: PopoverController,
		private navService: NavigationService,
		private analyticsService: AnalyticsService,
		private cdr: ChangeDetectorRef
	) {
		super(repository);
	}

	ngOnInit() {
		super.ngOnInit();
	}

	ngAfterViewInit() {
		// this.loadOrders();
	}

	ngOnDestroy(): void {
		this.destroy$.next(null);
		this.destroy$.complete();
	}

	nextSlide() {
		this.swiper.nativeElement.swiper.slideTo(1);
	}

	async loadOrders() {
		this.orders = [];
		if (!this.customer) {
			console.log('user not loaded');

			return;
		}
		try {
			const result = await Api.getCustomerOrders(this.customer.uid);
			if (result.data.withPayment) {
				const resultOrders = result.data.withPayment
					.concat(result.data.withoutPayment)
					.filter(it => it?.preorder?.type !== PreorderType.FOOD_SPOT);
				if (resultOrders.length > 20) {
					resultOrders.length = 20;
				}

				this.orders = resultOrders;
			}
		} catch (e) {}

		this.cdr.detectChanges();

		const slideOptions: SwiperOptions = {
			effect: 'slide',

			slidesPerView: 3,
			// centeredSlides: true,
			spaceBetween: 30,
			grabCursor: true,
			allowTouchMove: true,
		};

		console.log(!!this.swiper?.nativeElement);

		if (this.swiper?.nativeElement) {
			Object.assign(this.swiper.nativeElement, slideOptions);
		}
	}
	ionViewDidEnter() {
		if (history.state.navigationId === 1) {
			this.repository.onOrderChange(null);
		}
		this.repository.verifiedOrder.emit(null);
	}

	navigateToOrderType() {
		this.destroy$.next(true);
		this.navigationService.orderType();
	}

	// async navigateToMap() {
	// 	this.destroy$.next(true);
	// 	this.navigationService.map();
	// 	this.analyticsService.logFacebookPixelEvent(FacebookPixelEvent.OrderNow);
	// }

	async navigateToMap(type: PreorderType) {
		this.repository.defaultPreorderType$.next(type);
		await this.navigationService.map();
	}
	async checkGeolocation() {
		try {
			const address = await MapsUtils.getUserGeocode();
			this.repository.address.emit(address);
		} catch (e) {
			console.error(e);
			this.repository.address.emit(null);
		}
	}

	changeLang(language: string) {
		this.translate.setDefaultLang(language);
		this.translate.use(language);
	}

	async openPopoverLanuage(ev: any) {
		this.opened = true;
		const popover = await this.popover.create({
			component: SelectLanguagePopoverComponent,
			cssClass: 'popover-home',
			event: ev,
			translucent: true,
			showBackdrop: false,
			side: 'top',
			alignment: 'end',
			reference: 'event',
			componentProps: {
				lang: this.translate.currentLang,
			},
		});
		popover.onWillDismiss().then(v => {
			console.log(v);
			if (v.data) {
				this.translate.setDefaultLang(v.data);
				this.translate.use(v.data);
				this.selectedLanguage = v.data;
			}

			this.opened = false;
		});
		await popover.present();

		return;
	}

	selectedImage() {
		return '../../../assets/' + this.selectedLanguage + '.svg';
	}
	openPage(value: string) {
		if (!value) {
			return;
		}
		this.router.navigate([value]);
	}
	async askFoodSpotCode() {
		try {
			const result = await EnterFoodspotCodeModalComponent.show(this.modalCtrl);
			if (result && result?.openingHours?.length > 0) {
				result.openingHours = TimeUtils.sanitizeHours(result.openingHours);
				this.repository.companyCode$.next(result);
				if (result.venue) {
					const venue = await this.repository.getVenue(result.venue);
					await this.selectVenue(venue, PreorderType.FOOD_SPOT);
					await sleep(200);
				}
			}
		} catch (e) {}
	}

	async selectVenue(venue: Venue, preorderType: PreorderType, attempt: number = 0, prevError: any = null) {
		if (!venueAcceptsOrders(venue, preorderType)) {
			return;
		}

		try {
			await this.repository.getVenue(venue._id);
			this.repository.createOrder(venue, this.address, OrderType.PREORDER, preorderType);

			await sleep(1000);
			this.navService.foodSpot();

			this.loading = false;
		} catch (e) {
			this.loading = false;
			await this.selectVenue(venue, preorderType, attempt + 1, e);
		}
	}

	async openAuth() {
		this.analyticsService.logFacebookPixelEvent(FacebookPixelEvent.SignInOrJoin);
		const result = await SignInModalComponent.show(this.modalCtrl);
		await this.modalCtrl.dismiss().catch(e => {});
		if (result === 'sign-up') {
			await SignUpModalComponent.show(this.modalCtrl);
		}
		if (result === 'forgot-password') {
			await AppRestorePasswordModalComponent.show(this.modalCtrl);
		}
	}

	protected readonly PreorderType = PreorderType;
}
